module.exports = __webpack_public_path__ + "static/media/Asynchronous.d2029d08.jpg";